// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingModal_root__3m3n0","spinner":"LoadingModal_spinner__1tozA","text":"LoadingModal_text__1lhPQ"};